import Vue from 'vue';
import objectFitImages from 'object-fit-images';

import UserSettings from './../model/userSettings';
import common from './../module/common';
import FormSystemError from '../utils/form-error-constants';
import Config from "../../assets/js/config";
import ErrorReporter from "../../assets/js/Service/errorReporter";

const config = new Config();

const checkNavForIE = () => {
    let productMenuJQ;
    let floatBuyButton;
    let isIE = document.body.style.msTouchAction !== undefined;
    let productMenuTop = 50;
    let buyButtonHeight;
    let anchorMenuSpace;
    let productContainer;
    let endOfProductContainer;

    if (isIE) {
        floatBuyButton = $('.floatBuyButton');
        productMenuJQ = $('#productMenu');
        anchorMenuSpace = $('.anchorMenuSpace');
        productContainer = $('.main-cont > .productContainer');
        buyButtonHeight = floatBuyButton.innerHeight();
        endOfProductContainer = productContainer.height() + productContainer.position().top;

        if ($(document).scrollTop() > (anchorMenuSpace.position().top + 150)) {
            productMenuJQ.css({position: 'fixed', top: buyButtonHeight + productMenuTop});
        }

        if ($(document).scrollTop() > (endOfProductContainer - 200)) {
            productMenuJQ.css({position: 'absolute', top: 'auto'});
        }

        if ($(document).scrollTop() < anchorMenuSpace.position().top) {
            productMenuJQ.css({position: 'absolute', top: 'auto'});
        }
    }
};

let descriptionBlock;
let mq = window.matchMedia('(max-width: 740px)');
let isMobile = mq.matches;
let descriptionMore;
let opacityBlock;
let descriptionSectionContent;

const checkForSecondColumnDescription = () => {
    descriptionBlock = $('#productomschrijving');

    if (descriptionBlock) {
        descriptionSectionContent = descriptionBlock.find('.sectionContent ');
        descriptionMore = descriptionBlock.find('.descriptionMore');
        opacityBlock = descriptionBlock.find('.opacity-block');

        if (!isMobile) {
            if (descriptionMore.is(":visible")) {
                descriptionMore.show();
                opacityBlock.show();
            }
        }
    }
};

let addSeoEvents = () => {
    let seoButtons = $('.readMore .button');
    let buttonMinus;
    let buttonPlus;
    let textMore = $('.text.more');

    if (seoButtons.length) {
        buttonMinus = $(seoButtons[1]);
        buttonPlus = $(seoButtons[0]);

        buttonMinus.css('display', 'none');
        textMore.css('display', 'none');
    }

    seoButtons.click(function (event) {
        if (buttonMinus.css('display') === 'none') {
            buttonPlus.css('display', 'none');
            buttonMinus.css('display', 'block');
            textMore.css('display', 'block');
        } else {
            buttonMinus.css('display', 'none');
            buttonPlus.css('display', 'inline-flex');
            textMore.css('display', 'none');
        }
    });
};

const setMenuMaxHeight = () => {
    const $header = $('#header');

    setTimeout(() => {
        const headerVisibleHeight = $header.height() + $header.position().top;

        $('#accountMenuDropdown').css(isMobile ? 'height' : 'max-height', `calc(100vh - ${headerVisibleHeight}px)`);
    }, 0);
};

let afterFetchProductInfo = (component) => {
    if (component.$store.state.viewParams) {
        if (component.$store.state.viewParams.scrollPosition) {
            component.$nextTick(() => {
                $('html, body').scrollTop(component.$store.state.viewParams.scrollPosition);
            });
        }

        if (!component.$store.state.viewParams.backButton) {
            window.scrollTo(0, 0);
        }
    }
};

const toggleFloatBuyButton = (component) => {
    let isNeededToShow = null;
    let buyButtonPosition;
    let scrollPosition;
    let mq = window.matchMedia('(max-width: 740px)');

    if (component.$store) {
        if ((component.$store.state.currentView === 'product') && ($('.productSpecs .button.cart')[0]) && ($('#detailsVue .mainDetails').length > 0)) {
            buyButtonPosition = $('.productSpecs .button.cart')[0].offsetTop;
            scrollPosition = $(document).scrollTop();
            isNeededToShow = scrollPosition > buyButtonPosition;

            if (mq.matches) {
                $('.mobileBar, .bottomBar').toggleClass('hidden', isNeededToShow);
            }

            checkNavForIE();
        } else {
            $('#header').css('display', 'block');
        }

        if (isNeededToShow !== null) {
            component.$store.commit('setVisibilityFloatBuyButton', isNeededToShow);
        }
    }
};

const attachBaseEvents = () => {
    const $dropdown = $('.js_toggle');

    $dropdown.unbind('click');
    $dropdown.click((event) => {
        $(event.currentTarget.parentNode).toggleClass('is-active');
    });
};

const saveOrderedAlternative = (orderLineId, productId) => {
    $.post(`/dashboard/orders/orderlines/${orderLineId}/products/${productId}/alternatives`);
}

const attachSelectedAlternativePopupEvents = () => {
    const $closeButton = $('.js_selected-popup-button');
    const $orderedAlternativePopupBtn = $('.js_alternative-selected-btn');
    const $selectedAlternativeContainer = $('.js_selected-alternative-container');

    $orderedAlternativePopupBtn.each((index, item) => {
        const $item = $(item);

        $item.click((event) => {
            $selectedAlternativeContainer.removeClass('hidden');
        })
    })

    $closeButton.each((index, item) => {
        const $item = $(item);

        $item.click(() => {
            $selectedAlternativeContainer.addClass('hidden');
        });
    });
}

const attachOrderedAlternativesPopupHandlers = (orderLineId) => {
    const popupMainButton = $('.js_ordered-alternatives-popup-btn');
    const orderedAlternativesVariations = $('.js_change-ordered-alternatives-variation');
    let chosenVariationProductId = undefined;

    popupMainButton.unbind('click');
    orderedAlternativesVariations.unbind('click');

    orderedAlternativesVariations.click((event) => {
        const $currentTarget = $(event.currentTarget);
        const priceFormer = $currentTarget.data('priceformer');
        const variationColor = $currentTarget.find('span').attr('class');
        const variationText = $currentTarget.find('span').text();
        const variationStockText =  $currentTarget.data('stocktext');
        const $dropdown = $currentTarget.closest('.js_dropdown');
        const $orderedAlternativesCard = $currentTarget.closest('.js_ordered-alternative-card');
        const $stockText = $orderedAlternativesCard.find('.js_product-stock-text');
        const $stockColor = $orderedAlternativesCard.find('.js_product-stock-color');

        if (priceFormer) {
            $orderedAlternativesCard.find('.js_product-price-former.hidden').removeClass('hidden');
        }

        $orderedAlternativesCard.find('.js_product-price-former').text(priceFormer);
        $orderedAlternativesCard.find('.js_product-price').text($currentTarget.data('pricecurrent'));

        $stockColor.removeClass('black');
        $stockColor.removeClass('orange');
        $stockColor.removeClass('green');
        $stockColor.addClass(variationColor);
        $stockText.text(variationStockText);

        $dropdown.toggleClass('is-active');
        $dropdown.data('id', $currentTarget.data('id'));
        $dropdown.find('.js_product-variation-value').text(variationText);
        $currentTarget.closest('.js_dropdown-container').find('.js_error-bundle').removeClass('hidden');
        $currentTarget.closest('.js_dropdown-container').find('.js_error-bundle').addClass('hidden');
        chosenVariationProductId = $currentTarget.data('id');
    });

    popupMainButton.click((event) => {
        let isError = false

        $('.js_ordered-alternatives-checkbox').each((index, element) => {
            if (element.checked) {
                const $selectedItemFromAlternatives = $(element).closest('.js_ordered-alternative-card');
                const alternativeId = $selectedItemFromAlternatives.data('prodlevid');
                const hasVariations = !$selectedItemFromAlternatives.find('.js_dropdown-container').hasClass('hidden');
                const currentOrderedProductId = $('.js_ordered-product.js_current-ordered-product').data('prodlevid');

                if (hasVariations && !$selectedItemFromAlternatives.find('.js_dropdown').data('id')) {
                    $selectedItemFromAlternatives.find('.js_error-bundle').removeClass('hidden');
                    isError = true
                    return;
                }

                $(`.js_notification${currentOrderedProductId}`).remove();

                if (!$('.js_notification').length) {
                    $('.js_order-no-outstock-text').removeClass('hidden');
                }

                saveOrderedAlternative(orderLineId, chosenVariationProductId ? chosenVariationProductId : alternativeId);
            }
        });

        if (!isError) {
            $('.js_bundle-alternatives-popup-close').trigger('click');
        }
    });
};

let module = {
    attachAlternativeOrderedProducts() {
        const $popupBackground = $('.js_alternatives-popup-background');
        const $orderedAlternativesPopup = $('.js_ordered-alternatives-popup');
        const closePopup = () => {
            $popupBackground.removeClass('is-active');
            $('.js_body').toggleClass('overflow-hidden');
            $orderedAlternativesPopup.hide();
            $('.js_bundle-alternatives-popup-content').hide();
            $('.js_ordered-product.js_current-ordered-product').removeClass('js_current-ordered-product');
        };

        $('.js_open-ordered-alternatives-popup').click(async (event) => {
            event.preventDefault();

            const $currentTarget = $(event.currentTarget);
            const $orderedProductCard = $currentTarget.closest('.js_ordered-product');
            const orderLineId = $orderedProductCard.data('lineid');
            const template = await $.get(`/dashboard/orders/orderlines/${orderLineId}/alternatives`).catch(() => {
                location.reload();
            });
            const $orderedAlternativesPopupContent = $('.js_ordered-alternatives-popup-content');

            if (!template) {
                return;
            }

            $orderedAlternativesPopupContent.empty();
            $orderedAlternativesPopupContent.append(template);

            if (!$orderedAlternativesPopupContent.find('.js_ordered-alternatives-checkbox:checked').length) {
                $orderedAlternativesPopupContent.find('.js_ordered-alternatives-checkbox')[0].checked = true;
            }

            attachBaseEvents();
            attachOrderedAlternativesPopupHandlers(orderLineId);

            if (!isMobile) {
                $('html, body').scrollTop(0);
            }

            $('.js_body').toggleClass('overflow-hidden');
            $orderedProductCard.addClass('js_current-ordered-product');
            $popupBackground.not('.is-active').addClass('is-active');

            setTimeout(() => {
                $orderedAlternativesPopup.show();
                $('.js_bundle-alternatives-popup-content').animate({
                    height: 'toggle'
                }, 290);
                $orderedAlternativesPopupContent.scrollTop(0);
            }, 500)
        });

        $popupBackground.click(closePopup);
        $('.js_bundle-alternatives-popup-close').click(closePopup);

        const $alternativesPresent = $('.js_has-alternatives-items');
        const $alternativeButtonContainer = $('.js_show-alternatives-empty-block');
        const $orderedProduct = $('.js_ordered-product');

        if ($alternativesPresent.length && !isMobile) {
            $alternativeButtonContainer.each((i, item) => {
                $(item).addClass('visible');
            })
        } else {
            $alternativeButtonContainer.each((i, item) => {
                $(item).addClass('hidden');
                $orderedProduct.addClass('without-alternatives-btn');
            })
        }

        attachSelectedAlternativePopupEvents();
    },
    scrollHandlerForFloatButton(component) {
        window.addEventListener('scroll', function (e) {
            toggleFloatBuyButton(component);
        });
    },
    isFirefox() {
        return typeof InstallTrigger !== 'undefined';
    },
    userData: {},
    getApiUrl() {
        return window.env.publicApiUrl;
    },
    getMobileOperatingSystem() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    },
    isVideoYouTube(video) {
        return !((!isNaN(parseFloat(video)) && isFinite(video)) || ((typeof video === 'string') && video.substr(0, 2) === 'v:'));
    },
    getCookie(cname) {
        let name = `${cname}=`;
        let cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return "";
    },
    setCookie(cname, cvalue, exdays) {
        let date = new Date();
        date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = `expires=${date.toUTCString()}`;
        document.cookie = `${cname}=${cvalue};${expires};path=/`;
    },
    isFieldValid(component) {
        let success = true;
        for (let field in component.formData) {
            let errorInput = !component.formData[field];
            component.errors[field] = errorInput;
            if (errorInput && success) {
                success = false;
            }
        }
        if(this.checkEmailRegExp(component, component.errors.user_email, component.formData.user_email)) {
            component.errors.user_email = true;
            success = false;
        }
        component.$forceUpdate();
        return success;
    },
    validateEmail(formName, fieldName) {
        this.questionSent = false;
        if (fieldName === 'user_email'){
            const emailInputValue = this[formName].user_email;
            const isEmailInvalid = common.checkEmailRegExp(this, fieldName, emailInputValue);
            this.errors[fieldName] = isEmailInvalid;
        }
        else {
            this.errors[fieldName] = false;
        }
        this.$forceUpdate();
    },
    checkEmailRegExp(that, fieldName, emailInputValue) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm;
        return that.errors[fieldName] = !re.test(emailInputValue.trim());
    },
    fetchRenderProductInfo(component, product, callback) {
        Promise.all([
            component.$store.dispatch('getProduct', product.id),
            component.$store.dispatch('getRelatedProducts', product.id),
            component.$store.dispatch('getQuestions', product.commonId),
            component.$store.dispatch('getReviews', {commonId:product.commonId}),
        ]).then(([product, relatedProducts, questions, reviews, recommendations]) => {
            component.$store.dispatch('renderRecommendations', recommendations);
            component.$store.dispatch('renderReviews', {reviews:reviews, component:component});
            component.$store.dispatch('renderRelatedProducts', relatedProducts);
            component.$store.dispatch('renderQuestions', questions);
            component.$store.dispatch('renderProduct', product);

            callback(component);
        }).catch((error) => {
            ErrorReporter.report(error, {
                product: product,
                'source': 'fetchRenderProductInfo',
            });
        });
    },
    getSpecWarning(variation) {
        if (variation && variation.specificationName) {
            return variation.specificationName.toLowerCase()
        }

        return variation.specification && variation.specification.length ? variation.specification[0].name.toLowerCase() : ''
    },
    setGdprCookie(component) {
        $('body').removeClass('showCookieBar');
        component.gdprCookieExists = true;
    },
    gdprCookieInit() {
        this.gdprCookieExists = this.$cookie.get('gdprCookie') !== null || this.$cookie.get('__Host-gdprCookie') !== null;

        if (!this.gdprCookieExists) {
            $('body').addClass('showCookieBar');
            this.$cookie.set('__Host-gdprCookie', true, { expires: '1Y' });
        }
    },
    isObjectsEquivalent(a, b) {
        let aObject = JSON.parse(JSON.stringify(a));
        let bObject = JSON.parse(JSON.stringify(b));
        let aProps = Object.getOwnPropertyNames(aObject);
        let bProps = Object.getOwnPropertyNames(bObject);

        // If number of properties is different,
        // objects are not equivalent
        if (aProps.length != bProps.length) {
            return false;
        }

        for (let i = 0; i < aProps.length; i++) {
            let propName = aProps[i];

            // If values of same property are not equal,
            // objects are not equivalent
            if (JSON.stringify(aObject[propName]) !== JSON.stringify(bObject[propName])) {
                return false;
            }
        }

        // If we made it this far, objects
        // are considered equivalent
        return true;
    },
    setCartInfo(quantity) {
        $('div.cart .quantity').text(quantity);
    },
    getUserLoggedStatus(component) {
        const userData = window.customer;
        if (!userData) return;

        if (component.$store?.state.isLogged !== void(0)) {
            component.$store.state.isLogged = userData.isLogged;
        }

        if (component.$store?.state.user !== void(0)) {
            component.$store.commit('setUser', userData);
        }

        common.userData = userData;
        common.fillOutUserHeader(userData);
    },
    getUserInfo(component) {
        let VueCookie = require('vue-cookie');
        let cartLineCount = VueCookie.get('__Host-cartLineCount');
        if (VueCookie.get('cartLineCount') !== null) {
            VueCookie.delete('cartLineCount');
        }

        common.getStockMessage(component);

        if (null !== cartLineCount) {
            this.getUserLoggedStatus(component);
        } else {
            common.fillOutUserUnLoggedHeader();
            common.setCartInfo(0);
        }
    },
    concatChildrenAndParent(product) {
        if(product.variations && product.variations.length){
            return product.variations;
        } else if (product.specification) {
            return [product.variations];
        }

        return [];
     },
    changeMainProduct(component, product) {
        let lastParams = history.state;

        if(lastParams && (lastParams.currentView === 'product')){
            module.fetchRenderProductInfo(component, product, afterFetchProductInfo);
        }
    },
    attachSeoComponent(seoText) {
        Vue.component('SeoBlock', function(resolve, reject) {
            resolve({
                data: function () {
                    return {
                        templ:''
                    }
                },
                template: "<div v-html='templ'></div>",
                mounted(){
                    addSeoEvents();
                },
                created(){
                    this.templ = "<div>" + $("<div/>").html(seoText).text() + "</div>";
                }
            });
        });
    },
    getStockMessage(component, headerStockDisplay) {
        let stockMessage = headerStockDisplay || 'Voor 23:00 uur besteld, <span class="nowrap">morgen GRATIS bezorgd!</span>';
        component.stockMessage = $('<div></div>').html(stockMessage).text();
    },
    popstateHandler : (that, place) => {
        return (popstateObj) => {
            if (popstateObj.state) {
                let queryparams = JSON.parse(JSON.stringify(popstateObj.state.queryparams));
                let scrollPosition = popstateObj.state.scrollPosition;
                let firstPath;
                const top10 = popstateObj.state.currentView === 'top10';

                if (queryparams.prodlevid) {
                    return;
                } else if(queryparams.categoryId){
                    that.$store.commit('setView', {viewName:'theme',  viewParams:{categoryId:queryparams.categoryId, categoryUrl:queryparams.categoryUrl, backButton:true, scrollPosition: scrollPosition}});
                } else if(queryparams.reviewProduct){
                    firstPath = window.location.pathname.split('/')["1"];
                    if (window.document.referrer.indexOf(firstPath) === -1) {
                        window.location.reload(true);
                    }
                    that.$store.commit('setView', {viewName:'review', viewParams:{reviewProduct:queryparams.reviewProduct, backButton:true, scrollPosition:scrollPosition}});
                } else {
                    that.$store.commit('setQueryParams',  queryparams);

                    that.$store.dispatch('findFiltersInAjax', {query:that.$root.inputValue}).then((responseRequest) => {
                        that.$store.dispatch('productsFiltersRequest', {
                            scrollPosition:scrollPosition,
                            initial: true,
                            backButton:true,
                            checkedFilters: responseRequest.checkedFilters,
                            top10
                        });
                    });
                }
            } else {
                if(place !== 'reviewPagination'){
                    history.back();
                }
            }
        }
    },
    checkVariarionsForRequest(variations, specChecked){
        return !(variations.length && !specChecked);
    },
    dropdownFocusOut : () => {
        let dropdown = document.querySelectorAll('.dropdown');
        for (let i = dropdown.length - 1; i >= 0; i--) {
            module.removeClass(dropdown[i], 'is-active');
        }
    },
    removeClass : (element, className) => {
        if (element.classList) {
            element.classList.remove(className);
        }
        else {
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    },
    addClass : (element, className) => {
        if (element.classList) {
            element.classList.add(className);
        }
        else {
            element.className += ' ' + className;
        }
    },
    toggleClass : (element, className) => {
        let classes;
        let existingIndex;

        if (element.classList) {
            element.classList.toggle(className);
        } else {
            classes = element.className.split(' ');
            existingIndex = classes.indexOf(className);

            if (existingIndex >= 0)
                classes.splice(existingIndex, 1);
            else
                classes.push(className);

            element.className = classes.join(' ');
        }
    },
    checkFormFields : (formData, excluded) => {
        excluded = excluded || [];

        for (let field in formData){
            if (excluded.indexOf(field) === -1 && !formData[field]) {
                return false;
            }
        }

        return true;
    },
    isCurrentView : (value, currentView) => {
        return currentView === value
    },
    whishlistAction: (prodLevId, method) => {
        if (! ['add', 'remove'].includes(method)) {
            return;
        }

        return $.ajax({
            url: '/dashboard/wishlist',
            type: method === 'add' ? 'POST' : 'DELETE',
            data: JSON.stringify({
                productId: prodLevId,
            }),
            contentType: 'application/json',
            dataType: 'json'
        });
    },
    onSendEmailAnchor() {
        let $anchor = $(".customerserviceContainer .contactContainer a[href='#sendEmail']");
        let $anchorLink = $anchor.attr('href');

        $anchor.on("click", function (e) {
            this.scrollToAnchor($anchorLink);
            e.preventDefault();
            return false;
        }.bind(this));

        // Decline navigation to anchor if page was reloaded and accept if anchor appeared in a link
        if (window.location.href.indexOf('#sendEmail') !== -1 && performance.navigation.type === 0) {
            this.scrollToAnchor($anchorLink);
        }
    },
    onServiceFaqAnchor() {
        $(".customerserviceContainer .mainContent a[href*='#']").on("click", function (e) {
            this.scrollToAnchor($(e.target).closest("a").attr('href'));
            e.preventDefault();
            return false;
        }.bind(this));

        // Decline navigation to anchor if page was reloaded and accept if anchor appeared in a link
        if (/(?=.*klantenservice)(?=.*\#).*/.test(window.location.href)) {
            let urlWithAnchor = window.location.href.match(/\#(.*)/);
            if (urlWithAnchor) {
                let anchor = $("section#" + urlWithAnchor[1]);

                this.scrollToAnchor(anchor);
                let cookieBar = $('.js_cookie-bar');
                let cookieBarParent = cookieBar.parent();
                if (cookieBar.is(':visible')) {
                    if (cookieBarParent.not('.header-checkout')) {
                        cookieBarParent.css('transform', 'none');
                    }
                }
            }
        }
    },
    scrollToAnchor(anchor) {
        if(!$(anchor).length){
            return
        }

        $('html, body').stop().animate({
            scrollTop: $(anchor).offset().top - 140
        }, 1000);
    },
    changeWishlistTextTitle(element, method) {
        if(method === 'add'){
            $(element).attr('title', this.getProductWishlistText(true));
        } else{
            $(element).attr('title', this.getProductWishlistText(false));
        }
    },
    getProductWishlistText(inWishlist)
    {
        if (inWishlist) {
            return 'Verwijder product van de favorietenlijst';
        }

        return 'Voeg product toe aan de favorietenlijst';
    },
    fitIEImages(selector, options) {
        objectFitImages(selector, options);
    },
    addMetaTags(meta) {
        let title  = meta.title || 'FuturumShop.nl – dé shop voor wielrenners en mountainbikers';
        let description  = meta.description || '';
        let canonical = meta.canonical ? `${window.env.baseUrl}${meta.canonical}` : '';

        this.fillMeta(title, description, canonical);
        this.fillFacebookMeta(title, description);
    },
    fillMeta(title, descriptions, setCanonical) {
        document.title = title;
        setCanonical = setCanonical || window.location.href;
        let descriptionHeader = document.querySelector('meta[name="description"]');
        if (descriptionHeader) {
            descriptionHeader.setAttribute('content', descriptions);
        }

        let linkCanonical = document.querySelector('link[rel="canonical"]');
        if (linkCanonical) {
            linkCanonical.setAttribute('href', setCanonical);
        }
    },
    fillFacebookMeta(title, descriptions, image) {
        let titleHeader = document.querySelector('meta[property="og:title"]');
        if (titleHeader) {
            titleHeader.setAttribute('content', title);
        }
        let descriptionHeader = document.querySelector('meta[property="og:description"]');
        if (descriptionHeader) {
            descriptionHeader.setAttribute('content', descriptions);
        }

        let imageHeader = document.querySelector('meta[property="og:image"]');
        if (imageHeader && image) {
            imageHeader.setAttribute('content', image);
        }

        let ogUrl = document.querySelector('meta[property="og:url"]');
        if (ogUrl) {
            ogUrl.setAttribute('content', window.location.href);
        }
    },
    redirectToCart() {
        window.location.href = window.env.baseUrl + '?action=cart';
    },
    hideOnClickOutside(selector, callback) {
        const outsideClickListener = (event) => {
            if (!$(event.target).closest(selector).length) {
                if ($(selector).is(':visible')) {
                    callback();
                    removeClickListener()
                }
            }
        };

        const removeClickListener = () => {
            document.removeEventListener('click', outsideClickListener)
        };

        document.addEventListener('click', outsideClickListener)
    },
    asyncSendPageGoogleAnalytics() {
        if (typeof ga !== 'undefined') {
            ga('create', window.env.gaCode, 'auto');
            ga('send', 'pageview', location.pathname);
        }
    },
    refreshReviewRating(state, reviewRating) {
        this.setReviewRatingForProduct(window.staticData, reviewRating);
        /*for (let i = 0; i < state.relatedProducts.length; i++) {
            this.setReviewRatingForProduct(state.relatedProducts[i], reviewRating);
            let variations = this.concatChildrenAndParent(state.relatedProducts[i]);
            for (let j = 0; j < variations.length; j++) {
                this.setReviewRatingForProduct(variations[j], reviewRating);
            }
        }
        let variations = this.concatChildrenAndParent(state.currentProduct);
        for (let i = 0; i < variations.length; i++) {
            this.setReviewRatingForProduct(variations[i], reviewRating);
        }*/
    },
    setReviewRatingForProduct(product, reviewRating) {
        product.reviewRating.score = reviewRating.score;
        product.reviewRating.voted = reviewRating.voted;
    },
    getFixedProductRating: (product) => {
        return product.reviewRating.score ? Math.round(Number.parseFloat(product.reviewRating.score) * 10) / 10 : 0;
    },
    getButtonAddToCartTitle (component) {
        if (component.activeStock) {
            return 'Voeg toe aan winkelwagen';
        }

        if (!component.activeStock && window.categoryUrl) {
            return 'Bekijk alternatieven';
        }

        return 'Niet meer leverbaar';
    },
    getButtonAddToCartClass(component) {
        let result = 'button medium cart';

        if (!component.activeStock && !window.categoryUrl) {
            result += ' disabled';
        }

        if (!component.activeStock && window.categoryUrl) {
            result += ' blue';
        }

        return result;
    },
    getStockColor(colorClass){
        let classObj = {};

        if(colorClass){
            classObj[colorClass] = true;
        }

        return classObj;
    },
    clickSizeTable(event, component) {
        event.preventDefault();

        component.$root.sizeTableContent = window.sizeTable;
        component.$root.showModal_anchorSizetable = !component.$root.showModal_anchorSizetable;

        if (component.$root.showModal_anchorSizetable) {
            const $body = $('html, body');
            $body.animate({ scrollTop: 0 }, 500, 'swing');
        }
    },

    adjustTemplateForMobileScroll(event) {
        const parentElementJQ = $(event.currentTarget.parentElement);
        const liTags = parentElementJQ.find('.panel.left li');
        const minPadding = liTags.length * 3.5;
        const cardContainer = parentElementJQ.closest('.cardContainer');
        const currentPadding = +cardContainer.css('padding-bottom').replace('px', '');

        if(currentPadding < minPadding){
            cardContainer.css('padding-bottom', `${minPadding}rem`);
        }
    },

    toggleSpecialProductVariations(event) {
        let shouldAddClass = !$(event.currentTarget.parentNode).hasClass('is-active');
        $('.modalContent .dropdown').removeClass('is-active');

        this.adjustTemplateForMobileScroll(event);

        if(shouldAddClass){
            this.addClass(event.currentTarget.parentNode, 'is-active');
        } else {
            this.removeClass(event.currentTarget.parentNode, 'is-active');
        }
    },
    paginationClick(component, page) {
        let item = page.getItem;
        let lastPage = page.getLastPage;
        let currentPage = page.getCurrentPage;
        component.$store.commit('setCurrentPage', item);
        UserSettings.fillPagination(lastPage, currentPage);

        this.makeRequest(component);
    },
    paginationArrowClick(component, type) {
        UserSettings.paginationArrowClick(component, type);
        this.makeRequest(component);
    },
    makeRequest(component) {
        component.$store.commit('setPagination', {
            page:component.currentPage.number
        });

        component.$store.commit('setCurrentTrigger', 'pagination');
        component.$store.dispatch('productsFiltersRequest', {
            isCollection: component.$store.state.currentView === 'vendor'
        });
        component.$store.commit('setVisibilityMaxPage', component.currentPage);
    },
    clientDeviceType() {
        let MobileDetect = require('mobile-detect');
        return new MobileDetect(window.navigator.userAgent);
    },
    isDesktop() {
      return ! this.isMobile() && ! this.isTablet();
    },
    isMobile() {
        return !!this.clientDeviceType().mobile();
    },
    isTablet() {
        return !!this.clientDeviceType().tablet();
    },
    findProduct(product){
        let length = product.variations.length;
        let children = product.variations;
        let child;
        let defaultProductId = product.defaultProductId;
        let findProduct = product;

        for (let i = 0; i < length; i++) {
            child = children[i];
            if (child.id === defaultProductId) {
                findProduct = child;
                break;
            }
        }

        return findProduct;
    },
    checkForSecondColumnDescription() {
        checkForSecondColumnDescription();
    },
    showFullDescription:(event) => {
        let content;
        let opacityBlock;
        descriptionBlock = $("#productomschrijving");
        opacityBlock = descriptionBlock.find('.opacity-block ');
        descriptionSectionContent = descriptionBlock.find('.sectionContent ');
        content = descriptionSectionContent.find('.content ');
        let descriptionMore = descriptionBlock.find('.descriptionMore');
        descriptionMore.hide();
        descriptionSectionContent.height('auto');
        content.height('auto');
        opacityBlock.hide();
    },
    checkAndLoadLazyImages() {
        const lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));

        if (lazyImages.length) {
            this.loadLazyImages(lazyImages);
        }
    },
    loadLazyImages(lazyImages) {
      let active;

        let lazyLoad = function() {
            if (!active) {
                active = !active;

                setTimeout(() => {
                    lazyImages.forEach((lazyImage) => {
                        if ((lazyImage.getBoundingClientRect().top - 200 <= window.innerHeight && lazyImage.getBoundingClientRect().bottom + 200 >= 0) && getComputedStyle(lazyImage).display !== "none") {
                            lazyImage.src = lazyImage.dataset.src;
                            lazyImage.classList.remove("lazy");

                            lazyImages = lazyImages.filter((image) => {
                                return image !== lazyImage;
                            });

                            if (!lazyImages.length) {
                                document.removeEventListener('scroll', lazyLoad);
                                window.removeEventListener('orientationchange', lazyLoad);
                            }
                        }
                    });

                    active = false;
                }, 200);
            }
        };

        const options = {
            rootMargin: '200px 0px',
        };

        if ('IntersectionObserver' in window) {
            let lazyImageObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;

                        lazyImage.src = lazyImage.dataset.src;

                        lazyImage.classList.remove('lazy');
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            }, options);

            lazyImages.forEach( (lazyImage) => {
                lazyImageObserver.observe(lazyImage);
            });
        } else {
            document.addEventListener('scroll', lazyLoad);
            window.addEventListener('orientationchange', lazyLoad);
        }
    },
    fillOutUserHeader(userData) {
        let userName;

        if (userData) {
            if (userData.isLogged) {
                userName = userData.user_name;
                common.fillOutUserNameHeader(userName);
                common.fillOutSearchPlaceholder(userName);
            } else {
                common.fillOutUserUnLoggedHeader();
            }

            let cartLineCount = +userData.cartLineCount;
            common.setCartInfo(cartLineCount);
        }
    },
    fillOutSearchPlaceholder(userName) {
        let fcSearch = $('#fc_search');
        let customerPlaceholder = fcSearch.data('customerplaceholder');
        let placeholder = userName + customerPlaceholder;

        fcSearch.attr("placeholder", placeholder);
    },
    fillOutUserNameHeader(userName) {
        $('.accountHeader').find('.userName').text(userName).html();
    },
    fillOutUserUnLoggedHeader() {
        common.fillOutUserNameHeader('Inloggen');
    },
    showStockText(stock, getProductStockTextVariation) {
        if (getProductStockTextVariation.length > 0) {
            let result = getProductStockTextVariation.find(function(stockText) {
                return stockText.displayStock.stock === stock;
            });

            if (result) {
                return result.displayStock.showStock;
            }
        }

        return '';
    },
    showStockDisplay(component, isChangeUspsText) {
        let headerStockDisplay = window.stockMessages.stockDisplayMessageInHeader;

        $('.usps-header').each(function(item, element) {
            $(element).html(headerStockDisplay);
        });

        common.getStockMessage(component, headerStockDisplay);
        if (isChangeUspsText) {
            component.$store.commit('setUspsText', window.stockMessages.uspsText);
        }

        $('.usps-footer').each(function(item, element) {
            $(element).html(window.stockMessages.stockDisplayMessageInFooter);
        });
    },
    getNoticeErrorHtml(message) {
        return `
            <div class="notice">
                <div class="icon"><img src="${config.getImageDomain()}/svg/icon-error.svg" alt="Foutmelding"></div>
                <div class="text"> ${message} </div>
            </div>
        `;
    },
    accountHeaderClick() {
        if (this.userData.isLogged) {
            window.location.href = '/dashboard/account/profile';

            return;
        }

        window.location.href = '/?action=auth/login';
    },
};

export default module;
